import dayjs from "dayjs";

export const formatDateTime = (d: Date) => {
  dayjs.extend(require("dayjs/plugin/utc"));
  return dayjs(d, { utc: true }).format("DD/MM/YYYY");
};
